import { Base } from "./Base";

export enum MercantileType {
    Wheat = 'Pšenica',
    Barley = 'Ječam',
    OiledBeet = 'Uljana repica',
    Sunflower = 'Suncokret',
    Soya = 'Soja',
    Corn = 'Kukuruz',
}
export interface ParamSettings extends Base {
    id: string
    mercantile: MercantileType

    moisture: number // vlaga SRPS
    moistureMax: number // maksimalna vlaga za marginalne bonifikacije
    moistureMin: number // minimalna vlaga za marginalne bonifikacije
    impurity: number // primese SRPS
    impurityMax: number
    impurityMin: number
    breakage?: number // lom SRPS
    breakageMax?: number
    breakageMin?: number
    defect?: number // defekt SRPS
    defectMax?: number
    defectMin?: number
    hectoliter?: number
    hectoliterMax?: number // hektolitar
    hectoliterMin?: number
    calculateCalo?: boolean // obracunavati kalo?
}